module.exports = __webpack_public_path__ + "static/media/furniture.d7da0857.jpg";